import { ChevronLeft, ChevronRight, CalendarDays } from 'lucide-react';
import { fmtKoDate, fmtKoDow } from '../labels';

function shift(date: string, delta: number): string {
  const d = new Date(date + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + delta);
  return d.toISOString().slice(0, 10);
}
function todayKstStr(): string {
  const now = new Date();
  const kst = new Date(now.getTime() + 9 * 3600 * 1000);
  return kst.toISOString().slice(0, 10);
}

export default function DateNav({
  date, onChange, allowFuture = false,
}: {
  date: string; onChange: (d: string) => void; allowFuture?: boolean;
}) {
  const today = todayKstStr();
  const isToday = date === today;
  const isFutureBlocked = !allowFuture && date >= today;

  return (
    <div className="date-nav">
      <button className="nav-btn" type="button" onClick={() => onChange(shift(date, -1))} title="이전 날">
        <ChevronLeft size={16} />
      </button>
      <label className="date-display" title="클릭해서 날짜 선택">
        <CalendarDays size={14} className="date-display-icon" />
        <span className="ymd">{fmtKoDate(date)}</span>
        <span className="dow">{fmtKoDow(date)}</span>
        <input type="date" value={date} max={allowFuture ? undefined : today} onChange={e => e.target.value && onChange(e.target.value)} />
      </label>
      <button className="nav-btn" type="button" onClick={() => onChange(shift(date, 1))} disabled={isFutureBlocked} title="다음 날">
        <ChevronRight size={16} />
      </button>
      <button className={`quick-btn ${isToday ? 'today' : ''}`} type="button" onClick={() => onChange(today)} disabled={isToday}>오늘</button>
    </div>
  );
}
